<ng-template
  #buttonTemplate
  let-groups="groups"
  let-state="state"
  [ngTemplateType]="ButtonTemplateType"
>
  @for (buttons of groups; track trackByIndex($index, buttons); let last = $last) {
    <rt-group variant="stacked" layout-align-items-center>
      @for (button of buttons; track trackByValue(i, button); let i = $index) {
        @if (button.labelTranslationKey) {
          @if (!button.isDropdown) {
            @if (buttonWrapperTemplate) {
              <ng-container
                *ngTemplateOutlet="
                  buttonWrapperTemplate;
                  context: { button: button, content: outlinedButton, context: {} }
                "
              />
            } @else {
              <ng-container *ngTemplateOutlet="outlinedButton" />
            }
            <ng-template #outlinedButton>
              <rt-button
                #origin
                variant="outline"
                [rtTooltip]="tooltips[button.tooltipText!] || false"
                [disabled]="
                  disabled || !!(button.isDisabled && button.isDisabled(editorView().state))
                "
                [pressed]="editorHasFocus() && button.isActive(editorView().state)"
                (click)="onButtonClick(button, origin.elRef.nativeElement)"
              >
                <ng-container *ngTemplateOutlet="buttonContent; context: { button: button }" />
              </rt-button>
            </ng-template>
          } @else {
            @if (buttonWrapperTemplate) {
              <ng-container
                *ngTemplateOutlet="
                  buttonWrapperTemplate;
                  context: { button: button, content: dropdownButton, context: {} }
                "
              />
            } @else {
              <ng-container *ngTemplateOutlet="dropdownButton" />
            }
            <ng-template #dropdownButton>
              <rt-button
                #origin
                [dropdownOpened]="button.isActive(editorView().state)"
                [rtTooltip]="tooltips[button.tooltipText!] || false"
                variant="plain"
                size="small"
                [disabled]="
                  disabled || !!(button.isDisabled && button.isDisabled(editorView().state))
                "
                (click)="onButtonClick(button, origin.elRef.nativeElement)"
              >
                <ng-container *ngTemplateOutlet="buttonContent; context: { button: button }" />
              </rt-button>
            </ng-template>
          }
        } @else {
          @if (!button.isDropdown) {
            @if (buttonWrapperTemplate) {
              <ng-container
                *ngTemplateOutlet="
                  buttonWrapperTemplate;
                  context: { button: button, content: iconButton, context: {} }
                "
              />
            } @else {
              <ng-container *ngTemplateOutlet="iconButton" />
            }
            <ng-template #iconButton>
              <rt-icon-button
                #origin
                [id]="button.name"
                (click)="onButtonClick(button, origin.elRef.nativeElement)"
                [rtTooltip]="tooltips[button.tooltipText!] || false"
                [tabIndex]="-1"
                [pressed]="editorHasFocus() && button.isActive(editorView().state)"
                variant="plain"
                size="small"
                shape="square"
                [disabled]="
                  disabled || !!(button.isDisabled && button.isDisabled(editorView().state))
                "
                [iconName]="$any(button.icon)"
              />
            </ng-template>
          } @else {
            @if (buttonWrapperTemplate) {
              <ng-container
                *ngTemplateOutlet="
                  buttonWrapperTemplate;
                  context: { button: button, content: plainDropdownButton, context: {} }
                "
              />
            } @else {
              <ng-container *ngTemplateOutlet="plainDropdownButton" />
            }
            <ng-template #plainDropdownButton>
              <rt-button
                #origin
                [id]="button.name"
                [rtTooltip]="tooltips[button.tooltipText!] || false"
                [dropdownOpened]="button.isActive(editorView().state)"
                variant="plain"
                size="small"
                [disabled]="
                  disabled || !!(button.isDisabled && button.isDisabled(editorView().state))
                "
                (click)="onButtonClick(button, origin.elRef.nativeElement)"
                class="pm-icon-dropdown-trigger"
              >
                <rt-icon prefix [name]="$any(button.icon)" />
              </rt-button>
            </ng-template>
          }
        }
      }
    </rt-group>
    @if (!last) {
      <div class="separator"></div>
    }
  }
</ng-template>

<ng-template #buttonContent let-button="button" [ngTemplateType]="ButtonContentType">
  @if (button.icon) {
    <rt-icon [name]="$any(button.icon)" />
  }
  <span>{{ button | rtEditorButtonLabel: editorView() }}</span>
  @if (button.iconRight) {
    <rt-icon
      [name]="$any(button.iconRight)"
      [colorToken]="$any(button.iconRightColor)"
      size="small-x"
    />
  }
</ng-template>

<div class="outlet">
  <ng-container
    *ngTemplateOutlet="buttonTemplate; context: { groups: leftOutlet, state: leftOutletState }"
  />
  @if (moreOutlet.length) {
    <div class="separator"></div>
    <rt-icon-button
      #moreMenuTrigger="rtOverlayOrigin"
      rt-overlay-origin
      [active]="moreMenu.open"
      [rtTooltip]="'wysiwyg.more' | translate"
      [iconName]="'more-horiz'"
      (click)="moreMenu.open = !moreMenu.open"
      variant="plain"
      size="small"
      shape="square"
    />
    <ng-template
      #moreMenu="rtConnectedOverlay"
      rt-connected-overlay
      hasBackdrop
      [positions]="moreMenuPositions"
      [origin]="moreMenuTrigger"
      [open]="moreMenu.open"
      (backdropClick)="moreMenu.open = false"
    >
      <rt-dropdown [width]="DropdownWidth.SmallX" (click)="moreMenu.open = false">
        @for (button of moreOutlet; track $index) {
          <rt-dropdown-item
            (click)="onButtonClick(button, moreMenuTrigger.elementRef.nativeElement)"
          >
            @if (button.icon) {
              <rt-icon prefix [name]="$any(button.icon)" />
            }
            {{ button | rtEditorButtonLabel: editorView() }}</rt-dropdown-item
          >
        }
      </rt-dropdown>
    </ng-template>
  }
</div>
<div class="outlet">
  <ng-container
    *ngTemplateOutlet="buttonTemplate; context: { groups: [rightOutlet], state: rightOutletState }"
  />
</div>
<rt-wysiwyg-length-counter />
